<template>
  <div>
    <a-skeleton :loading="loadingItem" :paragraph="{ rows: 6 }">
      <div>
        <a-form-model
          ref="form"
          :model="form"
          :rules="rules"
          style="overflow-y: auto;"
        >
          <a-form-model-item
            has-feedback
            label="Code / Mã nhân viên"
            prop="code"
          >
            <a-input v-model="form.code" placeholder="Enter code" />
          </a-form-model-item>

          <a-form-model-item
            has-feedback
            label="Fullname / Họ và tên"
            prop="fullname"
          >
            <a-input v-model="form.fullname" placeholder="Write fullname" />
          </a-form-model-item>
          <a-form-model-item
            has-feedback
            label="Phone / Số điện thoại"
            prop="phone"
          >
            <a-input
              v-model="form.phone"
              placeholder="Enter text"
              :maxlength="80"
            />
          </a-form-model-item>

          <a-form-model-item label="Birthday / Ngày sinh" prop="birthday">
            <a-date-picker
              type="date"
              placeholder="Select date"
              style="width: 100%;"
              format="DD/MM/YYYY"
              :value="
                form.birthday
                  ? moment(
                      moment(form.birthday).format('DD/MM/YYYY'),
                      'DD/MM/YYYY'
                    )
                  : null
              "
              @change="changeBirthday"
            />
          </a-form-model-item>

          <a-form-model-item label="Started Date / Ngày vào công ty">
            <a-date-picker
              type="date"
              placeholder="Select date"
              style="width: 100%;"
              format="DD/MM/YYYY"
              :value="
                form.startedDate
                  ? moment(
                      moment(form.startedDate).format('DD/MM/YYYY'),
                      'DD/MM/YYYY'
                    )
                  : null
              "
              @change="
                (value) => {
                  form.startedDate = value;
                }
              "
            />
          </a-form-model-item>

          <a-form-model-item has-feedback label="Email" prop="email">
            <a-input v-model="form.email" placeholder="Nhập email" />
          </a-form-model-item>
          <a-form-model-item
            has-feedback
            label="Code Department / Mã phòng ban"
            prop="codeDepartment"
          >
            <a-input
              v-model="form.codeDepartment"
              placeholder="Nhập code department"
            />
          </a-form-model-item>
          <a-form-model-item has-feedback label="Cost Center" prop="costCenter">
            <a-input v-model="form.costCenter" placeholder="Nhập cost center" />
          </a-form-model-item>
          <a-form-model-item label="Gender / Giới tính" prop="gender">
            <a-select allowClear placeholder="-Chọn-" v-model="form.gender">
              <a-select-option value="NONE">
                Other
              </a-select-option>
              <a-select-option value="MALE">
                Male
              </a-select-option>
              <a-select-option value="FEMALE">
                Female
              </a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="Position / Chức vụ" prop="positionId">
            <SelectPosition
              v-model="form.positionId"
              :selectProps="{
                style: { width: '100%' },
                placeholder: 'Position',
                value: form.positionId,
              }"
              :isGetDataCreated="false"
              :initialDatas="form.position ? [form.position] : []"
            />
          </a-form-model-item>

          <a-form-model-item label="Department / Phòng ban" prop="departmentId">
            <SelectDepartment
              v-model="form.departmentId"
              :selectProps="{
                style: { width: '100%' },
                placeholder: 'Department',
                value: form.departmentId,
              }"
              :isGetDataCreated="false"
              :initialDatas="form.department ? [form.department] : []"
            />
          </a-form-model-item>
          <a-form-model-item
            label="Location / Địa điểm làm việc"
            prop="departmentId"
          >
            <SelectBranchLocation
              v-model="form.branchLocationId"
              :selectProps="{
                style: { width: '100%' },
                placeholder: 'Location',
                value: form.branchLocationId,
              }"
              :isGetDataCreated="false"
              :initialDatas="form.branchLocation ? [form.branchLocation] : []"
            />
          </a-form-model-item>
          <!-- <a-form-model-item
            label="Main shift / Ca làm việc chính thức"
            prop="departmentId"
          >
            <SelectWorkShift
              v-model="form.workShiftId"
              :selectProps="{
                style: { width: '100%' },
                placeholder: 'Shift',
                value: form.workShiftId || undefined,
              }"
              :variables-query="{ isOvertime: false }"
              :isGetDataCreated="false"
              :initialDatas="form.workShift ? [form.workShift] : []"
            />
          </a-form-model-item> -->

          <a-form-model-item
            label="Account / Người dùng"
            prop="userId"
            style="width: 100%;"
          >
            <div style="display: flex; justify-content: space-between;">
              <SelectUser
                v-model="form.userId"
                :selectProps="{
                  placeholder: 'Account',
                  style: { width: '100%' },
                  value: form.userId,
                }"
                :isGetDataCreated="false"
                :initialDatas="form.user ? [form.user] : []"
              />
              <a-button
                style="border: 0;"
                type="link"
                :loading="loadingDeleteUser"
                @click="unAssignUserFromEmployee"
                ><a-icon type="delete" style="color: red;"
              /></a-button>
            </div>
          </a-form-model-item>
        </a-form-model>
        <div
          style="text-align: right;"
          :style="{
            position: 'absolute',
            right: 0,
            bottom: 0,
            width: '100%',
            borderTop: '1px solid #e9e9e9',
            padding: '10px 16px',
            background: '#fff',
            textAlign: 'right',
            zIndex: 1,
          }"
        >
          <a-popconfirm
            title="Confirm action?"
            ok-text="Delete"
            cancel-text="Close"
            @confirm="
              () => {
                this.loadingDelete = true;
                deleteEmployee();
              }
            "
            style="float: left;"
          >
            <a-button type="danger" icon="delete" :loading="loadingDelete">
              Delete
            </a-button>
          </a-popconfirm>
          <a-button
            @click="closeDrawerUpdateEmployee"
            style="margin-right: 5px;"
          >
            Close
          </a-button>
          <a-button
            type="primary"
            @click="updateEmployee"
            icon="save"
            :loading="loadingUpdate"
          >
            Update
          </a-button>
        </div>
      </div>
    </a-skeleton>
  </div>
</template>
<script>
import moment from "moment";
import postQuery from "../../data/postData";
import getQuery from "../../data/getData";
import SelectPosition from "@/components/common/position/select";
import SelectDepartment from "@/components/common/department/select";
import SelectUser from "@/components/common/user/select";
import SelectBranchLocation from "@/components/common/branchLocation/select";
import SelectWorkShift from "@/components/common/workShift/select";

export default {
  components: {
    SelectPosition,
    SelectDepartment,
    SelectUser,
    SelectBranchLocation,
  },
  props: {
    updateEmployeeOnView: {
      type: Function,
      default: null,
    },
    closeDrawerUpdateEmployee: {
      type: Function,
      default: null,
    },
    formEmployee: {
      type: Object,
      default: null,
    },
    loadingItem: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let checkCode = (rule, value, callback) => {
      if (!this.regCode.test(this.form.code)) {
        callback(
          new Error(
            "Mã nhân viên yêu cầu tối thiểu 4 ký tự, không được trùng, không dấu cách, không dấu,ký tự đặc biệt trừ dấu _"
          )
        );
      } else {
        callback();
      }
    };
    let checkEmail = (rule, value, callback) => {
      if (!this.regEmail.test(this.form.email)) {
        if (this.form.email) {
          callback(
            new Error(
              "Email này không hợp lệ. Hãy đảm bảo rằng email được nhập dưới dạng example@email.com"
            )
          );
        } else {
          callback();
        }
      } else {
        callback();
      }
    };

    return {
      rules: {
        code: [
          {
            required: true,
            message: "Required / Mã nhân viên không được bỏ trống",
            trigger: "change",
          },
          { validator: checkCode, trigger: "change" },
        ],

        email: [{ validator: checkEmail, trigger: "change" }],
        fullname: [
          {
            required: true,
            message: "Required / Họ và tên không được bỏ trống",
            trigger: "change",
          },
        ],
        phone: [
          { max: 80, message: "Length should be to 80", trigger: "change" },
        ],
      },
      form: {},
      loadingDeleteUser: false,
      loadingDelete: false,
      loadingUpdate: false,
      regEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      regCode: /^\w{4,100}$/,
    };
  },
  methods: {
    moment,
    unAssignUserFromEmployee() {
      if (this.formEmployee?.userId) {
        this.formEmployee.userId = undefined;
        this.loadingDeleteUser = true;
        this.$apollo
          .mutate({
            mutation: postQuery.unAssignUserFromEmployee,
            variables: {
              id: this.formEmployee.id,
            },
          })
          .then(({ data }) => {
            if (data?.unAssignUserFromEmployee) {
              this.updateEmployeeOnView(data.unAssignUserFromEmployee);
              this.form.userId = undefined;
              this.formEmployee.userId = undefined;
            }
            this.$notification.success({
              message: "Success",
              description: "Updated Success!",
            });
            this.loadingDeleteUser = false;
          })
          .catch((error) => {
            console.log(
              "Xóa mối quan hệ giữa người dùng và nhân viên không thành công",
              error
            );
          });
      }
    },
    changeBirthday(birthday) {
      this.$set(this.form, "birthday", birthday);
    },
    updateEmployee() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loadingUpdate = true;
          // this.changeDataFormWhenPost();
          this.$apollo
            .mutate({
              mutation: postQuery.queryUpdateEmployee,
              variables: {
                ...this.form,
                positionId: this.form?.positionId ? this.form.positionId : null,
                departmentId: this.form?.departmentId
                  ? this.form.departmentId
                  : null,
                branchLocationId: this.form?.branchLocationId
                  ? this.form.branchLocationId
                  : null,
                userId: this.form?.userId ? this.form.userId : null,
                workShiftId: this.form?.workShiftId
                  ? this.form.workShiftId
                  : null,
              },
            })
            .then(({ data }) => {
              if (data?.updateEmployee) {
                this.$notification.success({
                  message: "Success",
                  description: "Updated Success!",
                });
                this.closeDrawerUpdateEmployee();
                this.updateEmployeeOnView(data.updateEmployee);
              }
              this.loadingUpdate = false;
            })
            .catch((error) => {
              this.$notification.error({
                message: "Error",
                description: "Updated Error!",
              });
              console.log("Không cập nhật được nhân viên", error);
              this.loadingUpdate = false;
            });
        } else {
          return false;
        }
      });
    },
    deleteEmployee() {
      this.loadingDelete = true;
      this.$apollo
        .mutate({
          mutation: postQuery.queryDeleteEmployee,
          variables: {
            id: this.formEmployee.id,
          },
        })
        .then((data) => {
          this.$notification.success({
            message: "Success",
            description: "Deleted Success!",
          });
          this.loadingDelete = false;
          this.$router.push({ name: "employee" });
        })
        .catch((error) => {
          this.loadingDelete = false;
          this.$notification.error({
            message: "Error",
            description: "Deleted Error!",
          });
          console.log("Xóa nhân viên không thành công", error);
        });
    },
  },
  created() {
    this.form = {
      ...this.formEmployee,
      userId: this.formEmployee.userId ? this.formEmployee.userId : undefined,
      positionId: this.formEmployee.positionId
        ? this.formEmployee.positionId
        : undefined,
      departmentId: this.formEmployee.departmentId
        ? this.formEmployee.departmentId
        : undefined,
      branchLocationId: this.formEmployee.branchLocationId
        ? this.formEmployee.branchLocationId
        : undefined,
    };
  },
};
</script>
